import type { Disposition } from "../api/types.ts"

/**
 * 처리방안 — 한국으로 돌려보내거나(return_kr) 일본에서 폐기한다(discard).
 * 서버 `server/src/domain/case-status.ts` 의 DISPOSITIONS 와 같아야 한다.
 *
 * 표기는 언어 사전(`disposition.*`)이 정한다.
 */
export const DISPOSITIONS = ["return_kr", "discard"] as const satisfies readonly Disposition[]

/**
 * 처리방안 칸이 미리 골라 두는 값. 반품은 거의 다 한국으로 돌려보낸다
 * — 폐기일 때만 바꿔 고른다.
 */
export const DEFAULT_DISPOSITION: Disposition = "return_kr"
